<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1200"
    @click:outside="clickOutside"
  >
    <template v-slot:activator="{ on, attrs }">
      <p id="payreqItemForm" v-bind="attrs" v-on="on" @click="openItemForm"></p>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5" style="margin: auto"
          >Formulir Tambah/Edit Item</span
        >
      </v-card-title>
      <v-form
        v-if="form != null"
        ref="formPayreqDetailItem"
        :readonly="loading || (detail.status != 0 && !form.isRevision)"
        lazy-validation
        @submit.prevent="saveForm"
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      padding: 0;
                      width: 210px;
                    "
                  >
                    Jenis Formulir
                  </p>
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.app_category"
                      mandatory
                      disabled
                      :column="false"
                    >
                      <div class="mr-3 d-flex" style="width: 160px">
                        <v-radio :value="1"></v-radio>
                        <p style="margin: 0; font-size: 12px">Payreq/CA</p>
                      </div>
                      <div class="d-flex" style="width: 160px">
                        <v-radio :value="2"></v-radio>
                        <p style="margin: 0; font-size: 12px">Bill</p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="form.app_category == 2">
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      padding: 0;
                      width: 210px;
                    "
                  >
                    Invoice
                  </p>
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.invoice_type"
                      mandatory
                      :column="false"
                    >
                      <div class="mr-3 d-flex" style="width: 160px">
                        <v-radio value="1"></v-radio>
                        <p style="margin: 0; font-size: 12px">
                          Cari Dari Sistem
                        </p>
                      </div>
                      <div class="d-flex" style="width: 160px">
                        <v-radio value="2"></v-radio>
                        <p style="margin: 0; font-size: 12px">Tulis Manual</p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
                <div
                  v-if="form.invoice_type == 1"
                  class="d-flex"
                  style="margin: 0; padding: 0; position: relative"
                >
                  <v-autocomplete
                    v-model="form.invoice"
                    :items="dropdown.invoice"
                    :filter="invoiceCustomFilter"
                    :search-input.sync="searchInvoice"
                    item-text="name"
                    item-value="id"
                    placeholder="Ketik invoice lalu enter"
                    style="font-size: 12px; height: 45px"
                    return-object
                    dense
                    outlined
                    clearable
                    @change="invoiceWatcher"
                    @keydown.enter.prevent="
                      invoiceQuerySelections(searchInvoice)
                    "
                    :loading="invoiceLoading"
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            <span style="font-size: 12px; margin-right: 5px">
                              {{ data.item.name }} |
                            </span>
                            <span style="font-size: 12px; margin-right: 5px">
                              {{ data.item.ref }} |
                            </span>
                            {{
                              data.item.partner != null
                                ? data.item.partner.display_name
                                : ''
                            }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-if="form.vendor_type == 0"
                    v-model="form.vendor_name"
                    :rules="rules.vendor_name"
                    dense
                    outlined
                    placeholder="Ketik nama vendor"
                    style="font-size: 12px; height: 45px"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="form.app_category != 2">
              <v-col
                v-if="form.directAdd == undefined && form.purchase_request != null"
                cols="6"
                class="d-flex flex-column"
              >
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                    width: 210px;
                  "
                >
                  Nama Barang
                </p>

                <v-text-field
                  v-if="act == 'update' && form.product != null"
                  :value="`(${form.product.code}) ${form.product.name}`"
                  dense
                  disabled
                  outlined
                  style="font-size: 12px; height: 45px"
                />

                <v-autocomplete
                  v-if="act == 'add'"
                  v-model="form.product"
                  :items="dropdown.fpbItem"
                  :rules="rules.productRules"
                  clearable
                  outlined
                  item-text="product.name"
                  item-value="product.id"
                  hide-details
                  hide-no-data
                  return-object
                  label=""
                  style="margin: 0"
                  @change="productWatcher"
                  @keydown.enter.prevent
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col v-else cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      width: 210px;
                    "
                  >
                    Nama Barang
                  </p>
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.select_from_catalogue"
                      mandatory
                      :column="false"
                    >
                      <div class="mr-3 d-flex" style="width: 160px">
                        <v-radio :value="1"></v-radio>
                        <p style="margin: 0; font-size: 12px">
                          Cari dari eKatalog
                        </p>
                      </div>
                      <div class="d-flex" style="width: 160px">
                        <v-radio :value="0"></v-radio>
                        <p style="margin: 0; font-size: 12px">Tulis Manual</p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
                <v-row>
                  <v-col v-if="!form.select_from_catalogue" cols="12">
                    <v-text-field
                      v-model="form.product_name"
                      dense
                      outlined
                      style="font-size: 12px; height: 45px"
                      @keydown.enter.prevent
                    />
                  </v-col>
                  <v-col v-else cols="12">
                    <v-autocomplete
                      v-model="form.product"
                      :items="dropdown.productCatalogue"
                      :filter="productCustomFilter"
                      @keydown.enter.prevent="enterSearchProduct(searchProduct)"
                      :rules="rules.productRules"
                      clearable
                      outlined
                      :label="form.product ? form.product.name : 'ketik produk lalu enter'"
                      item-text="product.name"
                      item-value="product.id"
                      hide-details
                      hide-no-data
                      return-object
                      style="margin: 0"
                      :search-input.sync="searchProduct"
                      @change="productWatcherV2"
                      dense
                    >
                      <template v-slot:prepend-item>
                        <div
                          style="
                            padding: 0 15px;
                            position: sticky;
                            top: 0;
                            z-index: 2;
                          "
                        >
                          <div
                            style="
                              padding: 0 25px;
                              height: 25px;
                              background: black;
                              color: white;
                              border: 2px solid black;
                              display: flex;
                              justify-content: flex-start;
                              align-items: center;
                            "
                          >
                            <v-toolbar-title
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 200px;
                              "
                            >
                              Item Name
                            </v-toolbar-title>
                            <v-divider class="mx-3" inset vertical></v-divider>
                            <v-toolbar-title
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 120px;
                              "
                            >
                              Item Code
                            </v-toolbar-title>

                            <v-divider class="mx-3" inset vertical></v-divider>

                            <v-toolbar-title
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 200px;
                              "
                            >
                              Supplier Catalog
                            </v-toolbar-title>
                            <v-divider class="mx-3" inset vertical></v-divider>
                            <v-toolbar-title
                              style="
                                text-align: left;
                                font-size: 14px;
                                padding: 0;
                                width: 120px;
                              "
                            >
                              Supplier code
                            </v-toolbar-title>
                          </div>
                        </div>
                      </template>
                      <template v-slot:item="{ item }">
                        <v-card
                          rounded
                          color="transparent"
                          style="
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            width: 800px;
                            padding: 7px;
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-toolbar-title
                                v-bind="attrs"
                                v-on="on"
                                style="
                                  text-align: left;
                                  font-size: 14px;
                                  padding: 0;
                                  width: 200px;
                                "
                              >
                                {{ item.product.name }}
                              </v-toolbar-title>
                            </template>
                            <span>{{ item.product.name }}</span>
                          </v-tooltip>
                          <v-divider class="mx-3" inset vertical></v-divider>
                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 120px;
                            "
                          >
                            #{{ item.product.code }}
                          </v-toolbar-title>

                          <v-divider class="mx-3" inset vertical></v-divider>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-toolbar-title
                                v-bind="attrs"
                                v-on="on"
                                style="
                                  text-align: left;
                                  font-size: 14px;
                                  padding: 0;
                                  width: 200px;
                                "
                              >
                                {{
                                  item.vendor.name !== null
                                    ? item.vendor.name
                                    : ''
                                }}
                              </v-toolbar-title>
                            </template>
                            <span>{{
                              item.vendor.name !== null ? item.vendor.name : ''
                            }}</span>
                          </v-tooltip>

                          <v-divider class="mx-3" inset vertical></v-divider>

                          <v-toolbar-title
                            style="
                              text-align: left;
                              font-size: 14px;
                              padding: 0;
                              width: 120px;
                            "
                          >
                            #{{
                              item.vendor.code !== null ? item.vendor.code : ''
                            }}
                          </v-toolbar-title>
                        </v-card>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="3"
                class="d-flex flex-column"
                v-if="act == 'add' && form.product != null"
              >
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Kode Product
                </p>

                <v-text-field
                  :value="form.product.product.code"
                  dense
                  outlined
                  disabled
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                v-if="
                  act == 'add' &&
                  form.product == null &&
                  form.directAdd == undefined
                "
              ></v-col>
              <v-col cols="12" md="3" v-if="act == 'update'"></v-col>
              <v-col cols="12" md="6" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Harga FPB
                </p>

                <!-- :disabled="form.directAdd == undefined" -->
                <v-text-field
                  v-model="form.price_demand"
                  dense
                  outlined
                  type="number"
                  min="0"
                  disabled
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="6" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Harga Dibayarkan
                </p>

                <v-text-field
                  v-model="form.price_request"
                  :rules="rules.priceRequestRules"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  {{ form.isRevision ? 'Qty Original' : 'Qty FPB' }}
                </p>

                <v-text-field
                  v-if="form.directAdd == undefined"
                  :value="
                    form.isRevision
                      ? form.qty_request
                      : form.qty_demand
                  "
                  dense
                  outlined
                  type="number"
                  min="0"
                  disabled
                  style="font-size: 12px; height: 45px"
                />
                <v-text-field
                  v-else
                  v-model="form.qty_demand"
                  dense
                  outlined
                  type="number"
                  min="0"
                  disabled
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Qty Tersedia
                </p>

                <v-text-field
                  v-if="form.prd_id != null"
                  :value="
                    form.isRevision
                      ? form.qty_request
                      : form.qty_demand - form.qty_paid - form.processed
                  "
                  dense
                  outlined
                  type="number"
                  min="0"
                  disabled
                  style="font-size: 12px; height: 45px"
                />
                <v-text-field
                  v-else
                  :value="form.qty_demand - form.qty_paid"
                  dense
                  outlined
                  type="number"
                  min="0"
                  disabled
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Qty Request
                </p>

                <v-text-field
                  v-model="form.qty_request"
                  :rules="rules.qtyRequestRules"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
                <!-- :max="form.qty_left - form.processed" -->
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Satuan
                </p>

                <v-autocomplete
                  v-model="form.uom"
                  :items="dropdown.unit"
                  :disabled="form.directAdd == undefined && detail.purchase_request != null"
                  item-text="name"
                  item-value="id"
                  style="font-size: 12px; height: 45px"
                  return-object
                  dense
                  outlined
                  clearable
                  :readable="form.directAdd == undefined && detail.purchase_request != null"
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Discount (%)
                </p>

                <v-text-field
                  v-model="form.discount_percent"
                  @change="discPercentWatcher"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Discount Amount
                </p>

                <v-text-field
                  v-model="form.discount_amount"
                  @change="discAmountWatcher"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Pajak
                </p>
                <v-autocomplete
                  v-model="form.tax_type"
                  :items="dropdown.tax"
                  item-text="name"
                  item-value="id"
                  style="font-size: 12px; height: 45px"
                  return-id
                  dense
                  outlined
                  clearable
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>

              <!-- <v-col cols="12" md="12" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Total
                </p>

                <v-text-field
                  :value="calculateTotalPrice()"
                  dense
                  outlined
                  disabled
                  style="font-size: 12px; height: 45px"
                />
              </v-col> -->
              <v-col cols="12" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Link Toko
                </p>
                <v-text-field
                  @click:append="openStoreLink(form.store_link)"
                  :value="form.store_link"
                  dense
                  outlined
                  readonly
                  append-icon="mdi-open-in-new"
                  prepend-icon=""
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col cols="12" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Keterangan
                </p>
                <v-textarea
                  v-model="form.description"
                  dense
                  outlined
                  rows="3"
                  style="font-size: 12px"
                  @keydown.enter.prevent
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Invoice No.
                </p>

                <v-text-field
                  v-model="form.invoice_no"
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="6" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Bill No.
                </p>

                <v-text-field
                  v-model="form.odoo_bill_no"
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Tgl. Invoice
                </p>

                <v-text-field
                  v-model="form.invoice_date"
                  dense
                  outlined
                  type="date"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Tgl. Terima Faktur
                </p>

                <v-text-field
                  v-model="form.receive_invoice_date"
                  dense
                  outlined
                  type="date"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Tgl. Jatuh Tempo
                </p>

                <v-text-field
                  v-model="form.invoice_due_date"
                  dense
                  outlined
                  type="date"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
                <!-- :max="form.qty_left - form.processed" -->
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Nilai Faktur
                </p>

                <v-text-field
                  v-model="form.total_after_tax"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>

              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Potongan
                </p>

                <v-text-field
                  v-model="form.deduction"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                  @change="deductionWatcher"
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Hutang
                </p>

                <v-text-field
                  v-model="form.debt_value"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Pajak
                </p>
                <v-autocomplete
                  v-model="form.tax_type"
                  :items="dropdown.tax"
                  item-text="name"
                  item-value="id"
                  style="font-size: 12px; height: 45px"
                  return-id
                  dense
                  outlined
                  clearable
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row
              v-if="
                (form.app_category == 2 && form.invoice_type == 2) ||
                form.app_category != 2
              "
            >
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      padding: 0;
                      width: 210px;
                    "
                  >
                    Pilih Vendor / Dibayarkan Kepada
                  </p>
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.vendor_type"
                      mandatory
                      :column="false"
                    >
                      <div class="mr-3 d-flex" style="width: 160px">
                        <v-radio value="1"></v-radio>
                        <p style="margin: 0; font-size: 12px">
                          Cari dari eKatalog
                        </p>
                      </div>
                      <div class="d-flex" style="width: 160px">
                        <v-radio value="0"></v-radio>
                        <p style="margin: 0; font-size: 12px">Tulis Manual</p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="margin: 0; padding: 0; position: relative"
                >
                  <v-autocomplete
                    v-if="form.vendor_type == 1"
                    v-model="form.vendor"
                    :items="dropdown.vendor"
                    :search-input.sync="searchVendor"
                    :rules="rules.vendor"
                    :filter="vendorCustomFilter"
                    item-text="name"
                    item-value="code"
                    :placeholder="`${
                      form.vendor_code
                        ? `(${form.vendor_code}) ${form.vendor_name}`
                        : 'Cari nama vendor'
                    }`"
                    style="font-size: 12px; height: 45px"
                    return-object
                    dense
                    outlined
                    clearable
                    @keydown.enter.prevent
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title class="d-flex">
                            <span style="font-size: 12px; margin-right: 5px">
                              ({{ data.item.code }})
                            </span>
                            {{ data.item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-if="form.vendor_type == 0"
                    v-model="form.vendor_name"
                    :rules="rules.vendor_name"
                    dense
                    outlined
                    placeholder="Ketik nama vendor"
                    style="font-size: 12px; height: 45px"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div style="padding: 0 25px 20px; width: 100%">
            <v-btn
              style="width: 100%"
              color="blue darken-1"
              class="white--text"
              type="submit"
              :loading="loading"
              :disabled="loading || (detail.status != 0 && !form.isRevision)"
            >
              SIMPAN
            </v-btn>
            <v-btn
              style="width: 100%; margin-top: 15px"
              color="pink"
              class="white--text"
              type="button"
              @click="closeDialog"
              :loading="loading"
            >
              BATAL
            </v-btn>
          </div>
          <!-- <v-btn color="blue darken-1" text type="submit"> Save </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import buildType from '../../../services/buildType.js'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'payreqItemForm',
  props: ['detail', 'itemDetail', 'act', 'proc', 'dropdownVendor'],
  data() {
    return {
      config: require('../../../services/config.json')[env],
      odooApi: buildType.apiURL('odoo'),
      dialog: false,
      form: null,
      dropdown: {
        unit: [],
        fpbItem: [],
        tax: [
          {
            id: 6,
            name: 'PPn 12% Inc'
          },
          {
            id: 7,
            name: 'PPn 12% Exc'
          }
          // {
          //   id: 5,
          //   name: 'PPh 22 (0,3%)'
          // }
        ],
        vendor: [],
        invoice: [],
        productCatalogue: []
      },
      rules: {
        productRules: [],
        qtyRequestRules: [],
        priceRequestRules: [],
        vendor: [],
        vendor_name: []
      },
      loading: false,
      searchVendor: null,
      selectedVendor: null,
      searchInvoice: null,
      invoiceLoading: false,
      selectedInvoice: null,
      selectProduct: null,
      searchProduct: null
    }
  },
  watch: {
    searchVendor(val) {
      if (val !== '') {
        val && val !== this.selectedVendor && this.querySelections(val)
      } else {
        this.selectedVendor = null
        this.dropdown.vendor = []
      }
    },
    'form.vendor_type'() {
      if (this.form != null) {
        if (this.detail.vendor_name || this.detail.vendor) {
          this.form.vendor = this.detail.vendor
          this.form.vendor_name = this.detail.vendor_name
        } else {
          this.form.vendor = null
          this.form.vendor_name = null
        }
      }
    }
    // 'form.deduction'(val) {
    //   console.log(val)
    //   if (this.form != null) {
    //     if (val != undefined && val != null && val != '') {
    //       this.form.debt_value = parseFloat(this.form.total_after_tax) - parseFloat(val)
    //     }
    //   }
    // }
    // searchInvoice(val) {
    //   if (val !== '') {
    //     val && val !== this.selectedInvoice && this.invoiceQuerySelections(val)
    //   } else {
    //     this.selectedInvoice = null
    //     this.dropdown.invoice = []
    //   }
    // }
  },
  computed: {},
  mounted() {},
  methods: {
    deductionWatcher(val) {
      if (this.form != null) {
        if (val != undefined && val != null && val != '') {
          this.form.debt_value = parseFloat(this.form.total_after_tax) - parseFloat(val)
        }
      }
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    /* eslint-disable indent */
    invoiceCustomFilter(item, queryText, itemText) {
      if (item.name && item.ref) {
        return (
          item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
            -1 ||
          item.ref.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
            -1
        )
      } else {
        return null
      }
      // ||
      // item.partner != null
      // ? item.partner.display_name
      //     .toLocaleLowerCase()
      //     .indexOf(queryText.toLocaleLowerCase()) > -1
      // : ''
    },
    /* eslint-enable indent */
    vendorCustomFilter(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.code.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1
      )
    },
    productCustomFilter(item, queryText, itemText) {
      if (item.vendor.name === null || item.vendor.code === null) {
        return (
          item.product.name
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1 ||
          item.product.code
            .toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        )
      }
      return (
        item.product.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.product.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.name
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.vendor.code
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      )
    },
    querySelections(v, str) {
      const url = `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=10&order_by=name&order_type=asc`
      axios
        .get(url)
        .then((res) => {
          // this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: res.data.data[i].id,
                code: res.data.data[i].code,
                name: res.data.data[i].name
              })
            }
            if (str != undefined && str == 'update') {
              if (resArr.length > 0) {
                Object.assign(this.form, {
                  vendor: resArr[0]
                })
                this.selectedVendor = resArr[0]
              }
            }
            return (this.dropdown.vendor = resArr)
          }
          return (this.dropdown.vendor = [])
        })
        .catch((err) => {
          this.dropdown.vendor = []
          return console.log(err)
        })
    },
    invoiceQuerySelections(v, str) {
      this.invoiceLoading = true
      // console.log('get bill', this.detail)
      let url = `${this.odooApi}account_move/list?keyword=${v}&limit=100&offset=0`
      if (this.detail && this.detail.company) {
        url = url + `&company_id=${this.detail.company.id}`
      }
      if (this.detail && this.detail.company_id) {
        url = url + `&company_id=${this.detail.company_id}`
      }
      url = url + '&type=in_invoice'
      axios
        .get(url)
        .then((res) => {
          // console.log(res)
          // this.loading = false
          this.invoiceLoading = false
          if (res.data.status_code === '00') {
            return (this.dropdown.invoice = res.data.data)
          } else {
            return (this.dropdown.invoice = [])
          }
        })
        .catch((err) => {
          this.dropdown.invoice = []
          this.invoiceLoading = false
          return console.log(err)
        })
    },
    discPercentWatcher() {
      if (
        this.form.discount_percent != null &&
        this.form.discount_percent != 0
      ) {
        const disc = this.form.discount_percent
        const price = this.form.price_request
        this.form.discount_amount = price * (disc / 100)
      } else {
        this.form.discount_amount = 0
        this.form.discount_percent = 0
      }
    },
    discAmountWatcher() {
      if (this.form.discount_amount != null && this.form.discount_amount != 0) {
        this.form.discount_percent = 0
      } else {
        this.form.discount_percent = 0
        this.form.discount_amount = 0
      }
    },
    dropdownUnit() {
      // console.log('hereee>>.', this.proc)
      axios
        .get(`${this.proc}master/unit/drop_down?keyword=`)
        .then((res) => {
          this.dropdown.unit = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async openItemForm() {
      console.log('openItem>>>>', this.detail)
      let processedQty = 0
      if (this.act == 'add') {
        this.form = {
          act: this.act,
          vendor_type: 1,
          vendor: null,
          vendor_name: null,
          app_category: this.detail.app_category,
          invoice_type: 2,
          select_from_catalogue: this.detail.select_from_catalogue,
          directAdd: this.detail.directAdd
        }
        if (this.detail) {
          this.form.vendor_type = this.detail.vendor_type
          if (this.detail.vendor_name || this.detail.vendor) {
            this.form.vendor = this.detail.vendor
            this.form.vendor_name = this.detail.vendor_name
          }
          if (this.dropdownVendor) {
            this.dropdown.vendor = this.dropdownVendor
          }
        }
        // sparate form payreq billing (app_category == 2) and non billing
        if (this.detail.app_category != 2) {
          Object.assign(this.form, {
            qty_demand: 0,
            price_demand: 0,
            qty_paid: 0,
            product: null,
            uom: null,
            qty_request: 0,
            price_request: 0,
            discount_amount: 0,
            discount_percent: 0,
            tax_type: null,
            description: '',
            processed: processedQty,
            store_link: null
          })
          if (this.detail.purchase_request != undefined) {
            this.getFpbItemDropdown()
          }
        } else {
          Object.assign(this.form, {
            odoo_bill_no: null,
            invoice_no: null,
            invoice_date: null,
            vendor_code: null,
            total_after_tax: 0,
            receive_invoice_date: null,
            invoice_due_date: null,
            deduction: 0,
            debt_value: 0,
            company_id: null
          })
        }
      } else if (this.act == 'update') {
        if (this.detail.app_category != 2) {
          this.form = {
            act: this.act,
            app_category: Number(this.detail.app_category),
            invoice_type: 2
          }
          let xLink = null
          if (this.itemDetail.prd_id != null) {
            processedQty = await this.calulateTotalQty(this.itemDetail.prd_id)
          }
          if (this.itemDetail.purchase_request_detail != null) {
            xLink = this.itemDetail.purchase_request_detail.store_link
          } else {
            xLink = this.itemDetail.store_link
          }
          if (this.itemDetail.product_name) {
            this.enterSearchProduct(this.itemDetail.product_name)
          }
          Object.assign(this.form, {
            qty_demand:
              this.itemDetail.purchase_request_detail != null
                ? this.itemDetail.purchase_request_detail.qty
                : this.itemDetail.qty_request,
            price_demand:
              this.itemDetail.purchase_request_detail != null
                ? this.itemDetail.purchase_request_detail.unit_price
                : this.itemDetail.price_request,
            qty_paid:
              this.itemDetail.purchase_request_detail != null
                ? this.itemDetail.purchase_request_detail.qty_paid
                : 0,
            product: {
              id: this.itemDetail.product_id,
              code: this.itemDetail.product_code,
              name: this.itemDetail.product_name
            },
            product_name: this.itemDetail.product_name,
            uom: {
              id: this.itemDetail.uom_id,
              name: this.itemDetail.uom_name
            },
            qty_request: this.itemDetail.qty_request,
            price_request: this.itemDetail.price_request,
            discount_amount: this.itemDetail.discount_amount,
            discount_percent: this.itemDetail.discount_percent,
            tax_type: this.itemDetail.tax_type,
            description: this.itemDetail.description,
            processed: processedQty - this.itemDetail.qty_request,
            store_link: xLink,
            vendor: {
              id: this.itemDetail.vendor_id,
              code: this.itemDetail.vendor_code,
              name: this.itemDetail.vendor_name
            }
          })
        } else {
          this.form = {
            act: this.act,
            app_category: Number(this.detail.app_category),
            invoice_type: 2,
            odoo_bill_no: null,
            invoice_no: null,
            invoice_date: null,
            vendor_code: null,
            vendor_name: null,
            total_after_tax: 0,
            receive_invoice_date: null,
            invoice_due_date: null,
            deduction: 0,
            debt_value: 0,
            company_id: null
          }
          Object.assign(this.form, {
            odoo_bill_no: this.itemDetail.odoo_bill_no,
            invoice_no: this.itemDetail.invoice_no,
            invoice_date: this.itemDetail.invoice_date,
            vendor_code: this.itemDetail.vendor_code,
            vendor_name: this.itemDetail.vendor_name,
            total_after_tax: this.itemDetail.total_after_tax,
            receive_invoice_date: this.itemDetail.receive_invoice_date,
            invoice_due_date: this.itemDetail.invoice_due_date,
            deduction: this.itemDetail.deduction,
            debt_value: this.itemDetail.debt_value,
            company_id: this.itemDetail.company_id,
            tax_type: this.itemDetail.tax_type
          })
        }
        if (this.itemDetail.vendor_code) {
          this.querySelections(this.itemDetail.vendor_code, 'update')
        }
        if (this.itemDetail.isRevision) {
          Object.assign(this.form, {
            isRevision: this.itemDetail.isRevision,
            origin_qty_request: this.itemDetail.qty_request
            // item_type: 2,
            // status: -1
            // qty_left: this.form.qty_left
          })
        }
      }
      this.dropdownUnit()
    },
    // clear() {
    //   this.$emit('loadPage')
    // },
    clickOutside() {
      //   this.closeDialog()
    },
    closeDialog() {
      this.dialog = false
      if (this.form.isRevision) {
        delete this.itemDetail.isRevision
      }
      setTimeout(() => {
        this.form = null
        this.selectedVendor = null
        this.dropdown.vendor = []
        this.dropdown.invoice = []
        this.$emit('closeForm')
      }, 200)
    },
    saveForm() {
      if (this.detail.app_category != 2) {
        this.rules.qtyRequestRules = [
          (v) => !!v || 'Wajib diisi',
          (v) => v > 0 || 'Tidak boleh kosong'
        ]
        if (this.detail.purchase_request != null) {
          if (!this.form.isRevision) {
            this.rules.qtyRequestRules.push(
              (v) =>
                v <=
                  this.form.qty_demand -
                    this.form.qty_paid -
                    this.form.processed ||
                `Melebihi qty yang dapat di request (${
                  this.form.qty_demand - this.form.qty_paid - this.form.processed
                })`
            )
          } else {
            this.rules.qtyRequestRules.push(
              (v) =>
                v <= this.form.origin_qty_request ||
                `Tidak dapat melebihi qty original (${this.form.origin_qty_request})`
            )
          }
        }
        this.rules.priceRequestRules = [(v) => !!v || 'Wajib diisi']
        this.rules.productRules = [(v) => !!v || 'Wajib diisi']
      } else {
        if (this.form.act == 'add') {
          const xCheckBill = this.detail.payment_request_detail.find(
            ({ odoo_bill_no, invoice_no }) =>
              odoo_bill_no == this.form.odoo_bill_no ||
              invoice_no == this.form.invoice_no
          )
          if (xCheckBill != undefined) {
            return this.showMsgDialog(
              'warning',
              `Invoice dengan no ${this.form.invoice_no} sudah terinput, tidak dapat menambahkan kembali`,
              true
            )
          }
        }
      }
      const self = this
      setTimeout(function () {
        if (self.$refs.formPayreqDetailItem.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      // console.log('this.form>>>', this.form)
      // console.log('this.form>>>', this.itemDetail)
      const newForm = {
        act: this.form.act,
        payment_request_id: this.detail.id
      }
      if (this.form.app_category != 2) {
        Object.assign(newForm, {
          qty_request: Number(this.form.qty_request),
          price_request: Number(this.form.price_request),
          discount_amount: Number(this.form.discount_amount),
          discount_percent: Number(this.form.discount_percent),
          tax_type: this.form.tax_type,
          description: this.form.description
        })
        if (this.form.act == 'add') {
          Object.assign(newForm, {
            uom_id: this.form.uom.id,
            uom_name: this.form.uom.name,
            qty_demand: this.form.qty_demand,
            price_demand: this.form.price_demand
          })
          if (this.form.select_from_catalogue && this.form.product != null) {
            Object.assign(newForm, {
              product_id: this.form.product.product.id,
              product_code: this.form.product.product.code,
              product_name: this.form.product.product.name
            })
          } else {
            Object.assign(newForm, {
              product_id: null,
              product_code: null,
              product_name: this.form.product_name
            })
          }
        }
        if (this.form.vendor_type == 1 && this.form.vendor != null) {
          Object.assign(newForm, {
            vendor_id: this.form.vendor.id,
            vendor_code: this.form.vendor.code,
            vendor_name: this.form.vendor.name
          })
        } else {
          Object.assign(newForm, {
            vendor_id: null,
            vendor_code: null,
            vendor_name: this.form.vendor_name
          })
        }
        if (this.form.act == 'update') {
          Object.assign(newForm, {
            id: this.itemDetail.id
            // prd_id: this.itemDetail.prd_id
          })
          if (this.itemDetail.prd_id != undefined) {
            Object.assign(newForm, {
              prd_id: this.itemDetail.prd_id
            })
          }
          if (this.form.isRevision) {
            Object.assign(newForm, {
              item_type: 2
            })
          }
        }
        let xFpbQty = 0
        if (this.form.act == 'add') {
          xFpbQty = this.form.qty_demand
        } else {
          xFpbQty =
            this.itemDetail.purchase_request_detail != null
              ? this.itemDetail.purchase_request_detail.qty
              : this.form.qty_demand
        }

        if (newForm.qty_request < xFpbQty) {
          this.showMsgDialog(
            'question',
            `${`jumlah request (${newForm.qty_request}) kurang dari qty FPB yang dapat diproses (${xFpbQty})`}, Lanjutkan ?`,
            true
          ).then((res) => {
            if (res.isConfirmed) {
              if (this.form.directAdd != undefined && this.form.directAdd) {
                this.dialog = false
                setTimeout(() => {
                  this.$emit('closeForm', newForm)
                  this.selectedVendor = null
                  this.dropdown.vendor = []
                  this.dropdown.productCatalogue = []
                  this.selectProduct = null
                  this.searchProduct = null
                }, 100)
              } else {
                this.submitDetailItem(newForm)
              }
            }
          })
        } else {
          if (this.form.directAdd != undefined && this.form.directAdd) {
            this.dialog = false
            setTimeout(() => {
              this.$emit('closeForm', newForm)
              this.selectedVendor = null
              this.dropdown.vendor = []
              this.dropdown.productCatalogue = []
              this.selectProduct = null
              this.searchProduct = null
            }, 100)
          } else {
            this.submitDetailItem(newForm)
          }
        }
      } else {
        Object.assign(newForm, {
          odoo_bill_no: this.form.odoo_bill_no,
          invoice_no: this.form.invoice_no,
          invoice_date: this.form.invoice_date,
          total_after_tax: this.form.total_after_tax,
          receive_invoice_date: this.form.receive_invoice_date,
          invoice_due_date: this.form.invoice_due_date,
          deduction: this.form.deduction,
          debt_value: this.form.debt_value,
          tax_type: this.form.tax_type
        })
        if (this.form.invoice_type == 2) {
          Object.assign(newForm, {
            company_id: this.itemDetail.company_id
          })
        } else {
          Object.assign(newForm, {
            company_id: this.form.company_id
          })
        }
        if (this.form.vendor) {
          Object.assign(newForm, {
            vendor_id: this.form.vendor.id,
            vendor_code: this.form.vendor.code,
            vendor_name: this.form.vendor.name
          })
        }
        if (this.form.act == 'update') {
          Object.assign(newForm, {
            id: this.itemDetail.id
          })
        }
        console.log('simpan item>>>', newForm)
        this.submitDetailItem(newForm)
      }
    },
    async submitDetailItem(form) {
      // console.log('submitDetailItem>>>', form)
      if (form.payment_request_id == undefined) {
        this.dialog = false
        return this.$emit('closeForm', form)
      }
      this.loading = true
      await axios
        .post(`${this.proc}payreq/detail/save`, form)
        .then((res) => {
          // console.log('save detail>>>', res.data)
          this.loading = false
          if (res.data.status_code == '00') {
            this.dialog = false
            setTimeout(() => {
              this.$emit('loadPage')
              this.$emit('closeForm')
              this.selectedVendor = null
              this.dropdown.vendor = []
            }, 200)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                `${res.data.status_msg}: ${res.data.error_msg[0].msg} (${res.data.error_msg[0].param})`,
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    enterSearchProduct(val) {
      // console.log('enterSearchProduct', val)
      axios
        .get(`${this.proc}vendor/catalogue/dropdown_product?keyword=${val}`)
        .then((res) => {
          // console.log('getProductDropdown>>>', res)
          if (res.data.status_code == '00') {
            this.dropdown.productCatalogue = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getFpbItemDropdown() {
      if (this.detail.app_category != 2) {
        const url = `${this.proc}fpb/detail/${this.detail.purchase_request.id}`
        // url = url + '&order_by=prd.id&order_type=ASC'
        axios
          .get(url)
          .then((res) => {
            if (res.data.status_code == '00') {
              if (res.data.data.purchase_request_detail != null) {
                this.dropdown.fpbItem = res.data.data.purchase_request_detail
                console.log('fpb detail item>>>', this.dropdown.fpbItem)
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    calculateTotalPrice() {
      let total = 0
      const qty = Number(
        this.form.qty_request != null ? this.form.qty_request : 0
      )
      const price = Number(
        this.form.price_request != null ? this.form.price_request : 0
      )
      const discount_amount = Number(
        this.form.discount_amount != null ? this.form.discount_amount : 0
      )

      const discount_precent = Number(
        this.form.discount_percent != null ? this.form.discount_percent : 0
      )

      const tax = 0
      // Number(this.form.tax != null ? this.form.tax : 0)

      const calc_before_discount = qty * price + tax
      // let calc_after_discount = 0

      if (discount_amount != 0 && discount_amount != null) {
        total = calc_before_discount - discount_amount
      } else if (discount_precent != 0 && discount_amount != null) {
        total =
          calc_before_discount - (calc_before_discount * discount_precent) / 100
      } else {
        total = calc_before_discount
      }

      return total
    },
    productWatcherV2(item) {
      console.log('productWatcherV2', item)
    },
    async productWatcher(item) {
      console.log(item)
      if (item != null) {
        this.form.processed = await this.calulateTotalQty(item.clear_id)
        this.form.qty_demand = item.qty
        this.form.price_demand = item.budget_price_per_unit
        this.form.price_request = item.budget_price_per_unit
        // this.form.qty_left = item.qty_left != null ? item.qty_left : 0
        this.form.uom = {
          id: item.uom_id,
          name: item.uom
        }

        this.rules.productRules = []
      }
    },
    invoiceWatcher(item) {
      console.log(item)
      if (item != null) {
        const xTotal = parseFloat(item.amount_total_signed)
        this.form.odoo_bill_no = item.name
        this.form.invoice_no = item.ref
        this.form.invoice_date = item.date
        this.form.total_after_tax = Math.abs(xTotal)
        this.form.receive_invoice_date = item.invoice_date
        this.form.invoice_due_date = item.invoice_date_due
        this.form.deduction = 0
        this.form.debt_value = Math.abs(xTotal - 0)
        if (item.company) {
          this.form.company_id = item.company.code_plant
        } else {
          this.form.company_id = item.company_id
        }
        this.form.vendor_code = item.partner != null ? item.partner.code : ''
        this.form.vendor_name = item.partner != null ? item.partner.name : ''
      }
    },
    async calulateTotalQty(xPrd_id) {
      let total = 0
      const xArrPyrItem = this.detail.payment_request_detail.filter(
        ({ prd_id }) => prd_id == xPrd_id
      )
      total = xArrPyrItem.reduce((accum, item) => accum + item.qty_request, 0)

      return total
    },
    openStoreLink(link) {
      if (link != null && link != '') {
        window.open(link, '_blank')
      } else {
        this.showMsgDialog('info', 'Link toko tidak tersedia', false)
      }
    }
  }
}
</script>
